import { AbstractSliderChild } from "./AbstractSliderChild.js";
class SliderBtn extends AbstractSliderChild {
  /**
   * Config.
   */
  static config = {
    name: "SliderBtn",
    options: {
      prev: Boolean,
      next: Boolean,
      contain: Boolean
    }
  };
  /**
   * Update attributes.
   */
  update(index) {
    if (this.$options.contain && !this.$parent.$options.contain) {
      this.$warn(
        `The contain option will only works if the parent Slider also has the contain option.`
      );
    }
    const isContainMaxState = this.$options.contain && this.$parent.$options.contain && this.$parent.containMaxState === this.$parent.getStates()[index].x[this.$parent.$options.mode];
    if (index === 0 && this.$options.prev || (index === this.$parent.indexMax || isContainMaxState) && this.$options.next) {
      this.$el.setAttribute("disabled", "");
    } else {
      this.$el.removeAttribute("disabled");
    }
  }
  /**
   * Go prev or next on click.
   */
  onClick() {
    const { prev, next } = this.$options;
    if (prev) {
      this.$parent.goPrev();
    } else if (next) {
      this.$parent.goNext();
    }
  }
}
export {
  SliderBtn
};
//# sourceMappingURL=SliderBtn.js.map
